<template>
  <!--产品选择组件 -->
  <el-dialog :title="title" style="color:white" :visible.sync="dialogFormVisible" append-to-body
    custom-class="topDialog">
    <div class="ytitle"> <span>{{ytitle}}</span>
      <el-button
        v-if="$route.path === '/remoteSenseData' || $route.path === '/subscriptionData' ? dynamicrsTags.length : dynamicTags.length"
        type="primary" size="mini" class="qingchu" @click="qingkong">清空</el-button>
    </div>
    <div class="biaoqianm">
      <el-tag :key="tag.value"
        v-for="tag in $route.path === '/remoteSenseData' || $route.path === '/subscriptionData' ? dynamicrsTags : dynamicTags"
        closable :disable-transitions="false" @close="handleClose(tag.id)">
        {{tag.name}}
      </el-tag>
    </div>
    <el-tabs type="card" class="tabs" tab-position="left" v-model="activeTab">
      <el-tab-pane :label="item.appliedfieldname" v-for="(item, index) in datainfos" :key="index"
        :name="item.appliedfieldname">
        <div class="kongjian" v-for="(itemi,indexi) in item.children" :key="indexi">
          <div class="satitle">
            <div style="padding-right: 65px;" class="kongzhi">
              <el-checkbox v-model="itemi.checkAll" @change="handleCheckAllChange(itemi,index,indexi)">
                {{itemi.product_name}}</el-checkbox>
            </div>
            <button class="numberspan"
              @click="handleIsopen($event)"><span>{{itemi.children.length}}/{{getNumber(itemi)}}</span><span><i
                  class="el-icon-arrow-down downi aa"></i></span></button>
          </div>
          <div class="isclosed">

            <el-checkbox v-model="city.checkAll" v-for="(city,indexj) in itemi.children" :label="city.product_type_code"
              :key="city.product_type_code" @change="handleCheckAllChangeitem(city,index,indexi,indexj)">
              {{city.product_name}}</el-checkbox>

          </div>
        </div>
      </el-tab-pane>

    </el-tabs>
    <div style="margin-top: 20px;text-align: center;">
      <el-button class="buttongtey" type="primary" @click="saveproduct">
        {{$route.path === '/subscriptionData' ? '下一步' : '确 定'}}</el-button>
      <el-button style="margin-left: 60px;" class="buttongteys" @click="dialogFormVisible = false">取 消</el-button>

    </div>
  </el-dialog>
</template>

<script>
import store from '../../vuex/index.js'
import '../../assets/fontawesome/css/all.css'
export default {
  name: 'HeadClassDialog',
  data () {
    return {
      datainfos: [],
      dynamicTags: [], // 当前选中的产品类别
      dynamicrsTags: [], // 当前选中的数据类别
      dialogFormVisible: false,
      lsobject: null,
      selectinfos: [],
      activeTab: ''
    }
  },
  props: ['msgFather', 'prodata'],
  created () {
    this.initActiveTab()
    this.resdatainfo()
    console.log(this.datainfos)
  },
  computed: {
    title () {
      return this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData' ? '遥感数据选择' : '遥感产品选择'
    },
    ytitle () {
      return this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData' ? '已选数据' : '已选产品'
    }
  },
  methods: {
    initActiveTab () {
      if (this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData') {
        this.activeTab = 'Sentinel'
      } else {
        this.activeTab = '灾害'
      }
    },
    // 产品分类选择
    saveproduct: function () {
      store.commit('setLoading', true)
      this.selectinfos = []
      console.log(this.selectinfos)
      var isadd = true
      this.datainfos.forEach(el => {
        if (el.children.length > 0) {
          el.children.forEach(eel => {
            if (eel.children.length > 0) {
              eel.children.forEach(eeel => {
                var job = {}
                if (eeel.checkAll === true) {
                  if (this.selectinfos.length > 0) {
                    this.selectinfos.forEach(es => {
                      if (es.id === eeel.product_type_code) {
                        isadd = false
                      }
                    })
                    if (isadd) {
                      job.id = eeel.product_type_code
                      job.name = eeel.product_name
                      job.code = eeel.code
                      this.selectinfos.push(job)
                    }
                  } else {
                    job.id = eeel.product_type_code
                    job.name = eeel.product_name
                    job.code = eeel.code
                    this.selectinfos.push(job)
                  }
                }
              })
            }
          })
        }
      })
      if (this.$route.path === '/subscriptionData' && this.selectinfos.length <= 0) {
        this.$message({
          message: '请选择数据',
          type: 'warning'
        })
        return
      }
      this.dialogFormVisible = false
      this.sendselestinfos()
    },
    getNumber: function (item) {
      var number = 0
      item.children.forEach(element => {
        if (element.checkAll) {
          number++
        }
      })
      return number
    },
    handleClose: function (tag) {
      let _this = this
      if (this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData') {
        this.dynamicrsTags.forEach(function (item, index) {
          if (item.id === tag) {
            _this.dynamicrsTags.splice(index, 1)
            // 取出当前分类下选中的集合
            // 一级分类
            let selectInfos = _this.datainfos.filter(datainfo => datainfo.appliedfielid === item.pid)
            // 二级分类
            let level2List = selectInfos[0].children.filter(selectInfo => selectInfo.product_type_code === item.id)
            // 更改选中的状态
            level2List.forEach(selectInfo => {
              selectInfo.checkAll = false
              selectInfo.children.forEach(baby => {
                baby.checkAll = false
              })
            })
          }
        })
      } else {
        this.dynamicTags.forEach(function (item, index) {
          if (item.id === tag) {
            _this.dynamicTags.splice(index, 1)
            // 取出当前分类下选中的集合
            // 一级分类
            let selectInfos = _this.datainfos.filter(datainfo => datainfo.appliedfielid === item.pid)
            // 二级分类
            let level2List = selectInfos[0].children.filter(selectInfo => selectInfo.product_type_code === item.id)
            // 更改选中的状态
            level2List.forEach(selectInfo => {
              selectInfo.checkAll = false
              selectInfo.children.forEach(baby => {
                baby.checkAll = false
              })
            })
          }
        })
      }
    },
    // 产品分类数据处理
    resdatainfo: function () {
      var onelevelinfos = []
      console.log(this.prodata)
      this.prodata.forEach((item, index) => {
        if (item.level === 2) {
          var t = true
          onelevelinfos.forEach((itemo, indexo) => {
            if (itemo.appliedfielid === item.appliedfielid) {
              t = false
            }
          })
          if (t) {
            var jobtwo = []
            this.prodata.forEach((itemj, indexj) => {
              if (itemj.level === 2 && itemj.appliedfielid === item.appliedfielid) {
                var jobthree = []
                this.prodata.forEach((itemk, indexk) => {
                  if (itemk.level === 3 && itemk.appliedfielid === itemj.product_type_code) {
                    var jkl = {
                      product_name: itemk.product_name,
                      product_type_code: itemk.product_type_code,
                      appliedfielid: itemk.appliedfielid,
                      code: itemk.code,
                      checkAll: false
                    }
                    jobthree.push(jkl)
                  }
                })
                var slk = {
                  product_name: itemj.product_name,
                  product_type_code: itemj.product_type_code,
                  appliedfielid: itemj.appliedfielid,
                  code: itemj.code,
                  checkAll: false,
                  children: jobthree
                }
                jobtwo.push(slk)
              }
            })
            var jobone = {
              appliedfieldname: item.appliedfieldname,
              appliedfielid: item.appliedfielid,
              code: item.code,
              children: jobtwo
            }
            onelevelinfos.push(jobone)
          }
        }
      })
      this.datainfos = onelevelinfos
    },
    // 产品一级分类最外层选择
    handleCheckAllChange: function (val, index, indexi) {
      this.datainfos.forEach(element => {
        element.children.forEach(item => {
          if (item.product_type_code === val.product_type_code) {
            if (val.checkAll) {
              item.checkAll = true
              item.children.forEach(info => {
                info.checkAll = true
              })
            } else {
              item.checkAll = false
              item.children.forEach(info => {
                info.checkAll = false
              })
            }
          }
        })
      })
      this.$set(this.datainfos, index, this.datainfos[index])
    },
    // 产品二级分类最外层选择
    handleCheckAllChangeitem: function (val, index, indexi, indexj) {
      this.datainfos.forEach(element => {
        element.children.forEach(item => {
          if (item.product_type_code === val.appliedfielid) {
            if (val.checkAll) {
              item.checkAll = true
              item.children.forEach(info => {
                if (info.product_type_code === val.product_type_code) {
                  info.checkAll = true
                }
              })
            } else {
              var ifaction = false
              item.children.forEach(info => {
                if (info.product_type_code === val.product_type_code) {
                  info.checkAll = false
                }
              })
              item.children.forEach(info => {
                if (info.checkAll) {
                  ifaction = true
                }
              })
              item.checkAll = ifaction
            }
          }
        })
      })
      this.$set(this.datainfos, index, this.datainfos[index])
    },
    handleIsopen: function (item) {
      var ccc = item.currentTarget
      if (ccc.parentElement.parentElement.classList.value === 'kongjian') {
        if (this.lsobject != null) {
          this.ishide(this.lsobject)
          this.lsobject = ccc
        } else {
          this.lsobject = ccc
        }
        this.isshow(ccc)
      } else {
        this.ishide(ccc)
      }
    },
    isshow: function (ccc) {
      ccc.childNodes[1].childNodes[0].classList.value = 'el-icon-arrow-down downi go'
      ccc.parentElement.parentElement.lastElementChild.classList.value = 'isopen'
      ccc.parentElement.parentElement.classList.value = 'kongjianis'
    },
    ishide: function (ccc) {
      ccc.childNodes[1].childNodes[0].classList.value = 'el-icon-arrow-down downi aa'
      ccc.parentElement.parentElement.lastElementChild.classList.value = 'isclosed'
      ccc.parentElement.parentElement.classList.value = 'kongjian'
    },
    sendselestinfos: function () {
      this.$emit('getproductselectinfos', this.selectinfos)
    },
    // 父子组件传值
    sendMsgToParent: function () {
      this.$emit('getdialogFormVisible', this.dialogFormVisible)
    },
    // 清空方法
    qingkong: function () {
      this.resdatainfo()
    }
  },
  watch: {
    msgFather: function (curVal) {
      this.dialogFormVisible = curVal
    },
    prodata: function (data) {
      this.resdatainfo()
    },
    dialogFormVisible: function () {
      this.sendMsgToParent()
    },
    datainfos: function () {
      if (this.$route.path === '/remoteSenseData' || this.$route.path === '/subscriptionData') {
        this.datainfos.forEach(element => {
          element.children.forEach(item => {
            if (item.checkAll) {
              var actions = true
              this.dynamicrsTags.forEach((items, index) => {
                if (items.id === item.product_type_code) {
                  actions = false
                }
              })
              if (actions) {
                var job = {
                  id: item.product_type_code,
                  name: item.product_name,
                  pid: item.appliedfielid
                }
                this.dynamicrsTags.push(job)
              }
            } else {
              this.dynamicrsTags.forEach((items, index) => {
                if (items.id === item.product_type_code) {
                  this.dynamicrsTags.splice(index, 1)
                }
              })
            }
          })
        })
        console.log(this.dynamicrsTags)
      } else {
        this.datainfos.forEach(element => {
          element.children.forEach(item => {
            if (item.checkAll) {
              var actions = true
              this.dynamicTags.forEach((items, index) => {
                if (items.id === item.product_type_code) {
                  actions = false
                }
              })
              if (actions) {
                var job = {
                  id: item.product_type_code,
                  name: item.product_name,
                  pid: item.appliedfielid
                }
                this.dynamicTags.push(job)
              }
            } else {
              this.dynamicTags.forEach((items, index) => {
                if (items.id === item.product_type_code) {
                  this.dynamicTags.splice(index, 1)
                }
              })
            }
          })
        })
        console.log(this.dynamicTags)
      }
    },
    $route (val) {
      if (val.path === '/remoteSenseData' || this.$route.path === '/subscriptionData') {
        this.activeTab = 'Sentinel'
      } else {
        this.activeTab = '灾害'
      }
    }
  }

}
</script>

<style >
.aa {
  transition: all 0.5s;
}
.go {
  transform: rotate(-180deg);
  transition: all 0.5s;
}
.isclosed {
  display: none;
}
.isopen {
  display: block;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.kongjian {
  padding: 10px;
  background-color: #ffffff;
  width: 45%;
}
.kongjianis {
  background-color: rgb(240, 249, 235);
  padding: 10px;
  width: 45%;
  border-radius: 4px;
}
.el-dialog__header {
  background: #1d202f;
  border-radius: 8px 8px 0 0;
  height: 1.25rem;
}
.dialog__header span {
  color: white;
}
/*.el-dialog {*/
.topDialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 66%;
}
.el-tabs__content {
  width: 80%;
}
.el-dialog__title {
  font-size: 16px;
  color: #ffffff;
}
.el-dialog__headerbtn {
  position: absolute;
  top: 15px;
  right: 15px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
  color: #ffffff;
}
.el-dialog__header {
  padding: 15px 20px 15px;
  text-align: left;
  line-height: 1;
}
.el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
}
.el-dialog__headerbtn .el-dialog__close:hover {
  color: rgb(28, 203, 150);
}
.tabs {
  border: 1px solid #e4e7ed;
  display: flex;
}
.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active {
  border-right-color: #fff;
  border-top: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
  background-color: #ffffff;
  color: #18bc9c;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left:hover {
  color: #18bc9c;
}
.el-tabs--left.el-tabs--card .el-tabs__item.is-left {
  border-left: none;
  border: none;
  border-bottom: none;
  text-align: center;
  border-right: 1px solid #e4e7ed;
}
.el-tabs--left.el-tabs--card .el-tabs__nav {
  border-radius: 4px 0 0 4px;
  border-bottom: none;
  border-right: none;
}
.el-tabs--card > .el-tabs__header {
  border-bottom: none;
}
.el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
  background-color: #eeeeee;
}
.el-tabs--left .el-tabs__header.is-left {
  float: none;
  margin-bottom: 0;
  margin-right: 0px;
  width: 20%;
}
.buttongtey {
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.buttongtey:hover {
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.buttongteys:hover {
  border-color: #18bc9c;
  color: #18bc9c;
}
.el-dialog__body {
  padding-top: 0px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
  color: #606266;
  font-size: 14px;
}
.biaoqianm {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
  text-align: left;
  margin-top: 10px;
}
.ytitle {
  text-align: left;
  color: #18bc9c;
  margin-top: 10px;
}
.qingchu {
  background-color: #18bc9c;
  border-color: #18bc9c;
  color: #ffffff;
  padding: 5px 5px;
  margin-left: 5px;
}
.qingchu.is-active {
  background-color: #18bc9c;
  border-color: #18bc9c;
  color: #ffffff;
}
.qingchu:focus {
  background-color: #18bc9c;
  border-color: #18bc9c;
  color: #ffffff;
}
.qingchu:hover {
  background-color: #18bc9c;
  border-color: #18bc9c;
  color: #ffffff;
}

.el-tab-pane {
  flex-wrap: wrap;
  display: flex;
  margin-left: 20px;
  justify-content: flex-start;
  margin-right: 16px;
  margin-top: 5px;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.el-checkbox__input.is-hover .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.el-checkbox__input.is_focus {
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.el-checkbox__inner.is_focus {
  background-color: #18bc9c;
  border-color: #18bc9c;
}
.el-checkbox__inner:hover {
  border-color: #18bc9c;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #18bc9c;
}
.el-checkbox__label {
  display: inline-block;
  padding-left: 10px;
  line-height: 30px;
  color: #18bc9c;
  font-size: 14px;
}
.isopen .el-checkbox {
  color: #606266;
  font-weight: 500;
  width: 45%;
  font-size: 14px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 8px;
  line-height: 2;
}
.satitle {
  display: flex;
  justify-content: flex-start;
  line-height: 1;
  width: 100%;
}
.kongzhi {
  width: 65%;
}
.el-tag {
  background-color: #18bc9c;
  padding: 0 10px;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  color: #ffffff;
  border-radius: 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #18bc9c;
  white-space: nowrap;
  margin-right: 10px;
  margin-bottom: 5px;
}
.el-tag .el-icon-close {
  border-radius: 50%;
  text-align: center;
  position: relative;
  cursor: pointer;
  font-size: 12px;
  height: 16px;
  width: 16px;
  line-height: 16px;
  top: -1px;
  right: -5px;
  color: #ffffff;
}
.el-tag .el-icon-close:hover {
  color: #ffffff;
  background-color: #18bc9c;
  font-weight: 800;
}
.numberspan {
  margin-right: 0px;
  font-size: 11px;
  color: #ffffff;
  border-radius: 4px;
  height: 20px;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 3px;
  padding-bottom: 3px;
  background-color: #18bc9c;
  cursor: pointer;
  border-width: 0px;
  border-style: outset;
  border-color: buttonface;
  border-image: initial;
  text-rendering: auto;
  letter-spacing: normal;
  word-spacing: normal;
  text-transform: none;
  text-indent: 0px;
  text-shadow: none;
  display: inline-block;
  text-align: start;
  margin: 0em;
  font: 100;
  box-sizing: border-box;
}
.numberspan:focus {
  border: 0px;
  outline: none;
}
.downi {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadMenu/HeadClassDialog.vue